import React from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import * as animationData from './arrows.json';

const BottomArrowNavButton = ({ onClick }) => (
  <div
    role='button'
    tabIndex={0}
    onKeyUp={onClick}
    style={{ marginTop: -20 }}
    onClick={onClick}
  >
    <Lottie
      speed={3}
      options={{
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      isClickToPauseDisabled
      height={55}
      width={50}
    />
  </div>
);

BottomArrowNavButton.propTypes = {
  onClick: PropTypes.func,
};

BottomArrowNavButton.defaultProps = {
  onClick: noop,
};

export default BottomArrowNavButton;
